import { Injectable } from '@angular/core';

import { Duration } from './jsonrpc/user-server.service';

export type DeltaDate = { days: number; months: number; years: number };

@Injectable({
  providedIn: 'root'
})
export class DurationService {
  constructor() {}

  public toIso(duration: DeltaDate): Duration {
    if (duration == null) return null;
    let str = 'P';
    if (duration.years) str += duration.years + 'Y';
    if (duration.months) str += duration.months + 'M';
    if (duration.days) str += duration.days + 'D';
    return str.length > 2 ? str : null;
  }

  public toDuration(iso: Duration | string): DeltaDate {
    // I am lazy: This matches only years/months/weeks/days, no times! Simply because we do not support it here.
    const str = iso as string;
    if (str == null) return null;
    const match = str.match(/^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?[THMS\d]*$/);
    if (match == null || match.length == 0) return null;
    let years: number, months: number, days: number;
    match
      .slice(1) // skip full match
      .filter(m => m) // why are there undefinde matches in between?! what ever...
      .forEach(m => {
        const val = Number.parseInt(m.substring(0, m.length - 1));
        if (val > 0) {
          switch (m.charAt(m.length - 1)) {
            case 'Y':
              years = val;
              break;
            case 'M':
              months = val;
              break;
            case 'W':
              days = val * 7;
              break;
            case 'D':
              days = val;
              break;
          }
        }
      });
    if (years || months || days) {
      return { days, months, years };
    } else {
      return null;
    }
  }

  public formatIso(iso: Duration | string): string {
    const d = this.toDuration(iso);
    return d != null ? this.format(d) : null;
  }

  public format(duration: DeltaDate): string {
    if (duration == null) return null;
    const str: string[] = [];
    if (duration.years > 0) str.push(this.fmt(duration.years, 'Year'));
    if (duration.months > 0) str.push(this.fmt(duration.months, 'Month'));
    if (duration.days > 0) str.push(this.fmt(duration.days, 'Day'));
    return str.join(', ');
  }

  private fmt(value: number, lookup: string): string {
    return value + ' ' + (value == 1 ? lookup : lookup + 's');
  }
}
